import React from 'react';

import { Link } from 'react-router-dom';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  GridLegacy as Grid,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Image from '../../Common/Image';

const imageOptions = {
  width: 170,
};

type Props = {
  offer: {
    result: App.Offer;
  };
  onRefresh: () => void;
};

export default function ImagesPane({ offer }: Props) {
  const { id_salesforce_external, images } = offer.result;

  return (
    <span>
      <h1>
        <Link to={'/edit-offers/' + id_salesforce_external + '/images'}>
          <IconButton aria-label="Edit">
            <ModeEditTwoToneIcon fontSize="large" />
          </IconButton>
        </Link>
      </h1>
      <Grid container spacing={2}>
        {images?.map((image) => (
          <Grid item key={image.id_image} sm={4}>
            <Card variant="outlined" sx={{ p: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Image className="img-responsive" publicId={image.id_cloudinary_external} options={imageOptions} />
              </Box>
              {image.title && (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {image.title}
                </Typography>
              )}
              {image.tags && (
                <Accordion sx={{ mt: 1 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls={`tags-${image.id_image}-content`}
                    id={`tags-${image.id_image}-header`}
                  >
                    <Typography variant="body2">tags</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      component="pre"
                      sx={{
                        m: 0,
                        p: 1,
                        bgcolor: 'background.default',
                        borderRadius: 1,
                        fontFamily: 'monospace',
                        fontSize: 12,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                        maxHeight: 160,
                        overflow: 'auto',
                      }}
                    >
                      {JSON.stringify(image.tags, null, 2)}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              )}
            </Card>
          </Grid>
        ))}
      </Grid>
    </span>
  );
}
